
<div class="separador"> </div>


<div class="separador"> </div>

<div class="d-flex" id="wrapper">
    <!-- Page Content -->
    <div id="page-content-wrapper">
        <nav class="navbar navbar-expand-lg navbar-light bg-cave border-bottom">
            <span class="usuario">{{nomusu}} </span>                 
        </nav>
        <div class="container-fluid text-center">
            <img class="imgportada" src="../../assets/img/logoacercade.png" alt="portada" style="max-width: 100%; height: auto;">
            <div class="mt-3 texto-cuadro"> <!-- Nueva clase para el cuadro de texto -->
                <p>Material Design Icons de Google   
                    https://material.io/resources/icons/                       
                    Licencia: Apache License, Version 2.0  
                                                                           
                    Open Sans de Google      
                    https://fonts.google.com/specimen/Open+Sans        
                    Licencia: Apache License, Version 2.0                      

                    ©  InfoGuadiana SL 2024    
                </p>
            </div>
        </div>
    </div>
    <!-- /#page-content-wrapper -->
</div>